<template>
  <div class="VideosUploader">
    <div class="p-header">视频管理器</div>
    <div class="p-body">
      <el-upload
        class="upload-demo"
        name="Filedata"
        :action="videoUpload()"
        :data="{ row_id: userRowID }"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :file-list="fileList"
        list-type="picture"
      >
        <el-button class="upload-pic-emmit" size="mini" type="primary">点击上传</el-button>
        <template #tip>
          <!-- <div class="el-upload__tip">
          只能上传 jpg/png 文件，且不超过 500kb
        </div> -->
        </template>
      </el-upload>

      <el-popover placement="bottom" popper-class="files-selector-video" :width="270" trigger="click">
        <div class="file-show-list">
          <div class="file-item" v-for="item in uploadedFileList" :key="item" @click="handleFileSelect(item)">
            <video :src="item" loop autoplay muted></video>
            <!-- <img src="@/assets/img/video.mp4" /> -->
          </div>
        </div>
        <template #reference>
          <el-button size="mini" class="upload-pic-manager" @click="getFilesList">视频选择</el-button>
        </template>
      </el-popover>
      <!-- <el-button class="upload-pic-manager" size="mini">图片管理</el-button> -->
    </div>
  </div>
</template>
<script>
  import {request} from '../../../common/request'
  import Api from '../../../apis/api'
export default {
  name: 'VideosUploader',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      fileList: [],
      userRowID: '',
      uploadedFileList: [],
      isOpenFileManager: false,
    };
  },
  created() {},
  mounted() {
    /* 获取初始值 */
    this.setUserRowID();
  },
  methods: {
    handlePreview() {},
    handleRemove() {},
    videoUpload(){
      return Api.videoUpload
    },
    handleChange(val) {
      /* 更新数据 */
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
    handleFileSelect(url) {
      console.log(url);
      this.handleChange(url);
    },
    getFilesList() {
      const url = `${Api.getFilesList}&type=video&row_id=${this.userRowID}`;
      // http://localhost/bigdatadisplaysystem_php/back/gthmmc/index.php?m=bdds&c=uploadWeb&a=getBgmaterial&type=image&row_id=4
      // this.axios.post(url).then(res => {
        let params = {
          method:'post',
          url:url,
          headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        }
        request(params).then(res => {
        if (res?.data?.list) {
          console.log(res);
          this.uploadedFileList = res?.data?.list.map(item => Api.host + item);
          console.log(this.uploadedFileList);
        }
      });
    },
    setUserRowID() {
      let info = window.localStorage.getItem('origin_userInfo');
      if (info) {
        let userinfo = JSON.parse(info);
        this.userRowID = userinfo.row_id;
      }
      // console.log('图片上传用户id', this.userRowID);
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
body .el-popper.files-selector-video {
  background: #2d313b;
  border: 1px solid #575e62;
  max-height: 500px;
  overflow-y: auto;

  &::-webkit-scrollbar-thumb {
    background: #6c45b4 !important;
    width: 4px !important;
    height: 3px !important;
  }
  &::-webkit-scrollbar {
    width: 4px !important;
    height: 3px !important;
  }
  &::-webkit-scrollbar-track {
    background: #43455800;
  }

  & .el-popper__arrow::before {
    background: #2d313b;
    border: 1px solid #575e62;
  }
  .file-show-list {
    width: 100%;
    // height: 800px;
    display: flex;
    flex-wrap: wrap;

    justify-content: space-between;
    padding-top: 10px;
    .file-item {
      cursor: pointer;
      flex-shrink: 0;
      margin-bottom: 20px;
      width: 104px;
      height: 90px;
      background-color: #1a1a1a;
      border: 1px solid #3179ff00;
      &:hover {
        border: 1px solid #6d62ff;
      }
      video {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>

<style scoped lang="scss">
// el-popover files-selector-video el-popper is-light

.VideosUploader {
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
  .p-header {
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    color: $property-title-color;
    font-size: $property-title-size;
    line-height: 30px;
  }
  .p-body {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 15px;
    position: relative;
    :deep().el-upload-list__item:first-child {
      margin-top: 20px !important;
    }
    :deep().el-upload-list__item {
      background-color: rgb(63, 67, 75);
      color: white;
      padding: 10px 10px 10px 10px;
      border: 1px solid rgb(171, 120, 253);
      .el-upload-list__item-thumbnail {
        display: none !important;
      }
      .el-upload-list__item-name {
        z-index: 20;
        font-size: 12px;
        color: white;
        .el-icon-document {
          display: none;
        }
      }
    }
    :deep().upload-demo {
      .el-progress {
        margin-top: 0px;
        top: 0 !important;
        .el-progress__text {
          color: white;
          top: -17px !important;
        }
      }
    }

    .upload-pic-emmit {
      background: linear-gradient(143deg, #3651c5, #686dff);
      color: #ffffff;
      border: #595dcb 1px solid;
      &:hover {
        background: linear-gradient(143deg, #335ae9, #6f6ff5);
        color: white;
        box-shadow: 1px 1px 1px rgb(24, 24, 24);
      }
    }

    .upload-pic-manager {
      position: absolute;
      top: 10px;
      right: 80px;
      background: linear-gradient(143deg, rgb(94, 70, 226), #15a1ffe8);
      color: #ffffff;
      border: #56bb03 0px solid;
      &:hover {
        background: linear-gradient(143deg, #7860ff, #15a1ff);
        color: white;
        // border: #56bb03 1px solid;
        box-shadow: 1px 1px 1px rgb(24, 24, 24);
      }
    }
  }
}
</style>
